module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ab6gA"))).then(() => parcelRequire('1iHdE'));